import React, { useEffect, useState } from 'react';
import { Tile, TileHeader, TileTitle, DropDown } from 'cantarus-react-ui';
import { TemplateStrings as Strings, ChangeTemplatePopUpStrings } from '../../utils/config';
import * as templateApi from '../../api/templateApi'
import Spinner from '../common/Spinner'
import TemplatePreview from './TemplatePreview'
import ConfirmationPopUp from '../PopUp/ConfirmationPopUp'
import './styles.css'

const TemplateDropDownList = ({ templateGroupId, templateId, onTemplateChange }) => {

    const [loading, setLoading] = useState(true);
    const [templates, setTemplates] = useState([]);
    const [selectedTemplateContent, setSelectedTemplateContent] = useState(null);
    const [showPopUp, setShowPopUp] = useState(false);
    const [templateIdToSave, setTemplateIdToSave] = useState(templateId);

    let selectedOption = null
    const dropdownPlaceholder = templates.length === 0 ? Strings.noTemplatesPlaceholder : Strings.placeholder;
    const dropdownOptions = templates.map(template => {
        const option = { value: template.Id, label: template.Name }
        if (option.value === templateId) {
            selectedOption = option
        }
        return option
    })

    const fetchTemplates = async () => {
        if (templateGroupId !== 0) {
            const groupTemplates = await templateApi.getAllTemplatesByGroupId(templateGroupId)
            setTemplates(groupTemplates);
        }
    }

    useEffect(() => {

        setLoading(true);
        fetchTemplates();

    }, [templateGroupId]);

    useEffect(() => {
        loading && setTimeout(() => setLoading(false), 750);
    }, [loading])

    useEffect(() => {

        const template = templates.find(template => template.Id === templateId);

        setSelectedTemplateContent(template ? template.Content : null);

    }, [templates, templateId]);

    const handleUserResponse = (userResponse) => {

        userResponse && onTemplateChange(templateIdToSave);

        setShowPopUp(false);
    }

    const handleTemplateChange = (id) => {
        if (templateId !== id && templateId > 0) {
            setTemplateIdToSave(id);
            setShowPopUp(true)
        }
        else {
            onTemplateChange(id);
        }
    }

    return (
        <div>
            <ConfirmationPopUp show={showPopUp} handleUserResponse={handleUserResponse} strings={ChangeTemplatePopUpStrings} />
            <Tile>
                <TileHeader>
                    <TileTitle>{Strings.header}</TileTitle>
                </TileHeader>
                {
                    loading ?
                        <Spinner /> :
                        <div>
                            <DropDown
                                onChange={(template) => handleTemplateChange(template.value)}
                                placeholder={dropdownPlaceholder}
                                disabled={templates.length === 0}
                                options={dropdownOptions}
                                selected={selectedOption}
                            />
                        </div>
                }
            </Tile>

            <Tile>
                <TileHeader>
                    <TileTitle>{Strings.previewHeader}</TileTitle>
                </TileHeader>
                <TemplatePreview previewContent={selectedTemplateContent} templateId={templateId} />
            </Tile>

        </div>
    )
};

export default TemplateDropDownList;
